export default __webpack_public_path__ + "static/media/2.d7e5d766.jpg";